import { render, staticRenderFns } from "./ViewServiceArea.vue?vue&type=template&id=3dc47a8b&scoped=true"
import script from "./ViewServiceArea.vue?vue&type=script&lang=js"
export * from "./ViewServiceArea.vue?vue&type=script&lang=js"
import style0 from "./ViewServiceArea.vue?vue&type=style&index=0&id=3dc47a8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc47a8b",
  null
  
)

export default component.exports